import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  Select,
  Text,
  Input,
  useToast,
  Flex
} from '@chakra-ui/react';
import { useMutation, useQuery } from 'react-query';
import { api } from '../../../../../services/api';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { useEffect } from 'react';
import { ListTag } from './ListTag';
import { CadastrarTag } from './CadastrarTag';

async function getCategorySite() {
  const response = await api.get('/site/v2/detalhes-produto/listar-categorias');

  return response.data.sort((a, b) => a.descricao_categoria.localeCompare(b.descricao_categoria));
}

async function updateTitleCategory(data) {
  const response = await api.post(
    '/site/v2/atualizacao-seo-categoria/atualiza-titulo-categoria',
    data
  );

  return response.data;
}

async function getRegisteredCategoryTitle(categoryId) {
  const response = await api.get(
    `/site/v2/atualizacao-seo-categoria/listar-titulo-categoria/${categoryId}`
  );

  return response.data;
}

const schema = z.object({
  categoria: z.string(),
  'new-title-category': z.string(),
  descricao: z.string().max(160, 'Máximo 160 caracteres')
});

export function Categoria() {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const {
    handleSubmit,
    register,
    watch,
    reset,
    formState: { errors },
    setValue
  } = useForm({
    resolver: zodResolver(schema)
  });

  const toast = useToast({
    position: 'top-right'
  });

  const codigoCategoria = watch('categoria');

  const { data: categorias } = useQuery({
    queryKey: 'categorias',
    queryFn: getCategorySite,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60 * 24,
    onSuccess: (data) => {
      console.log(data);
    }
  });

  const { data: registeredCategory } = useQuery({
    queryKey: ['registeredCategory', codigoCategoria],
    queryFn: () => getRegisteredCategoryTitle(codigoCategoria),
    refetchOnWindowFocus: false,
    enabled: !!codigoCategoria,
    onSuccess: (data) => {
      setValue('new-title-category', data[0].titulo_categoria);
      setValue('descricao', data[0].descricao_categoria);
      console.log(data);
    }
  });

  const { mutateAsync, isLoading: isSubmittingLoading } = useMutation({
    mutationFn: updateTitleCategory,
    onError: (error, variables, context) => {
      console.log('onError');
      toast({
        title: 'Erro ao atualizar título da categoria',
        status: 'error',
        duration: 2000,
        isClosable: true
      });
    },

    onSuccess: (data, variables, context) => {
      console.log('onSuccess');
      toast({
        title: 'Título da categoria atualizado com sucesso',
        status: 'success',
        duration: 2000,
        isClosable: true
      });
      reset();
      onClose();
    }
  });

  async function handleUpdateTitleTextCategory(data) {
    const params = {
      codigo_categoria: data.categoria,
      conteudo: data['new-title-category'],
      descricao_categoria: data.descricao
    };

    try {
      await mutateAsync(params);
    } catch (error) {
      console.error(error);
    }
  }

  const categorySelected = watch('categoria');

  useEffect(() => {
    if (!isOpen) {
      reset();
    }
  }, [isOpen, reset]);

  console.log('registeredCategory', registeredCategory);

  return (
    <>
      <Button onClick={onOpen} colorScheme="teal">
        Alterar título de Categoria
      </Button>

      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size="xl"
        //max H
      >
        <ModalOverlay />
        <ModalContent maxH="calc(100vh - 200px)" overflowY="auto">
          <ModalHeader>Alterar título de Categoria</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Select placeholder="Selecione uma categoria" {...register('categoria')}>
              {categorias?.map((category) => (
                <option key={category.codigo_grupo} value={category.codigo_grupo}>
                  {category.descricao_categoria}
                </option>
              ))}
            </Select>

            {categorySelected && (
              <>
                <Text
                  display="block"
                  mt={3}
                  as="label"
                  htmlFor="new-title-category"
                  color="gray.500"
                  fontSize="sm">
                  Digite o novo título para a categoria selecionada
                </Text>

                <Input
                  id="new-title-category"
                  type="text"
                  placeholder="Digite o novo título"
                  {...register('new-title-category')}
                />

                {errors['new-title-category'] && (
                  <Text color="red.500" fontSize="sm">
                    {errors['new-title-category'].message}
                  </Text>
                )}

                <Text
                  display="block"
                  mt={3}
                  as="label"
                  htmlFor="descricao"
                  color="gray.500"
                  fontSize="sm">
                  Digite a descrição para a categoria selecionada
                </Text>

                <Input
                  id="descricao"
                  type="text"
                  placeholder="Digite a descrição"
                  {...register('descricao')}
                />

                {errors.descricao && (
                  <Text color="red.500" fontSize="sm">
                    {errors.descricao.message}
                  </Text>
                )}

                <CadastrarTag />

                <Flex gap={7} flexWrap="wrap">
                  <ListTag listTags={registeredCategory[0]?.tags_categoria} />
                </Flex>
              </>
            )}
          </ModalBody>

          <ModalFooter>
            <Button variant="outline" mr={3} onClick={onClose}>
              Fechar
            </Button>
            <Button
              colorScheme="blue"
              isLoading={isSubmittingLoading}
              isDisabled={!categorySelected || isSubmittingLoading}
              onClick={handleSubmit(handleUpdateTitleTextCategory)}>
              Alterar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
